import React, { useMemo, useRef, useState, useCallback, useEffect, useContext } from 'react';
import { svgSprite } from '../../../hybrid/wrappers';
import { changeTableItemsLengthFunc } from '../utils';
import ExcelButton from '../../excelButton/ExcelButton';
import { t } from '../../../common/components/T';
import FormInput from '../../form/components/form-input/FormInput/FormInput';
import { getFilterForPage, getWidgetTranslates } from '../../../common/utils/utils';
import { LangContext } from '../../../common/decorators/Language';
import DropdownElement from '../../../hybrid/library/DropdownElement';
import { generateCompStylers, getStylePropsFunc } from '../../../common/utils/styles';
import SummaryHead from './GridFilterHeaderVariants/SummaryHead';
import OrderHead from './GridFilterHeaderVariants/OrderHead';
import BodyHead from './GridFilterHeaderVariants/BodyHead';
import CounterHead from './GridFilterHeaderVariants/CounterHead/CounterHeadSelectStatus';
import CounterHeadSelect from './GridFilterHeaderVariants/CounterHead/CounterHeadSelect/CounterHeadSelect';
import { useRouter } from 'next/router';
import qs from 'qs';

const AdminGridFilterHeader = ({
    compStyles,
    screenWidth,
    selectPageItemsArr,
    selectPageItemsValue,
    dataFiltersToUrl,
    dataFiltersItemsCountToUrl,
    setGridData,
    convertData,
    userToken,
    lang,
    inputGlobFilter,
    textsData,
    setShowModal,
    globalSearch,
    setAlertData,
    pageSettings = {},
    url,
    setUrl,
    exportData,
    filterParams,
    token,
    filter,
    translates,
    sort
}) => {
    const { stylers, classes } = generateCompStylers(compStyles);
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);
    const router = useRouter();
    const selectPageItems = useRef(selectPageItemsArr);
    const [selectedLengthItems, setSelectedLengthItems] = useState(selectPageItems.current[selectPageItemsValue]);
    const [transl, setTranslates] = useState(translates);
    const chamgeTableItemsLength = useCallback(
        (data) => {
            changeTableItemsLengthFunc(
                data.value,
                dataFiltersToUrl,
                dataFiltersItemsCountToUrl,
                setSelectedLengthItems,
                setGridData,
                convertData,
                setAlertData,
                userToken,
                lang,
                url,
                setUrl,
                filterParams,
                token,
                filter,
                sort,
                router
            );
        },
        [
            dataFiltersToUrl,
            dataFiltersItemsCountToUrl,
            setGridData,
            convertData,
            setAlertData,
            userToken,
            lang,
            url,
            setUrl,
            filterParams,
            token,
            filter,
            sort,
            router
        ]
    );
    const selectPageConfig = useMemo(
        () => ({
            className: 'adminTableFilterSelect',
            controlClassName: 'adminTableFilterSelect-dropdown-control',
            arrowClassName: 'adminTableFilterSelect-dropdown-arrow',
            options: selectPageItems.current,
            value: selectedLengthItems,
            onChange: chamgeTableItemsLength
        }),
        [selectedLengthItems, chamgeTableItemsLength]
    );
    useEffect(() => {
        const local_storage_params = getFilterForPage(router?.route);
        if (local_storage_params) {
            const parsed = qs.parse(local_storage_params);

            if (parsed?.page?.size) {
                setSelectedLengthItems(parsed?.page?.size);
            }
        }
    }, [router?.route]);
    const { translation } = useContext(LangContext) || {};
    useEffect(() => {
        if (translates) {
            setTranslates(translates);
        } else {
            getWidgetTranslates(lang, 'gridFilter', translation, setTranslates);
        }
    }, [lang, translation, translates]);
    const propsData = {
        setShowModal,
        transl,
        compStyles,
        screenWidth,
        textsData,
        pageSettings,
        inputGlobFilter,
        globalSearch,
        selectPageConfig,
        exportData,
        dataFiltersToUrl
    };
    if (pageSettings.structure === 'summary-head') {
        return <SummaryHead {...propsData} />;
    }
    if (pageSettings.structure === 'order-head') {
        return <OrderHead {...propsData} />;
    }
    if (pageSettings.structure === 'body-head') {
        return <BodyHead {...propsData} />;
    }
    if (pageSettings.structure === 'counter-head') {
        if (pageSettings.selectMenuData) {
            return (
                <CounterHeadSelect
                    selectMenuData={pageSettings.selectMenuData}
                    checkHandler={pageSettings.checkHandler}
                    value={pageSettings.value}
                    {...propsData}
                />
            );
        }
        return <CounterHead {...propsData} />;
    }
    return (
        <>
            <div style={stylers.tableButtonsBlock} className={classes.tableButtonsBlock}>
                <div {...getStyleProps('flexRow')}>
                    {textsData.settingsButton !== false ? (
                        !screenWidth ? (
                            <div>
                                {/*{svgSprite('gear', {*/} {/*})}*/}
                                {/*<p>{textsData.settingsButton || t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, "gridFilter" )}</p>*/}
                            </div>
                        ) : (
                            <div>
                                {/*{svgSprite('gear', {*/} {/*})}*/}
                            </div>
                        )
                    ) : textsData.pageTitle ? (
                        <p {...getStyleProps('pageTitleText')}>
                            {textsData.pageTitle ||
                                t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, 'gridFilter')}
                        </p>
                    ) : null}
                </div>

                <div {...getStyleProps('flexRow')}>
                    {!filter?.hidePaginationSettings ? (
                        <div {...getStyleProps('selectPageWrap')}>
                            <p {...getStyleProps('selectPageText')}>
                                {(textsData.itemOnPage ||
                                    (screenWidth
                                        ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                        : t(
                                              'gridHeader-sselectPageText',
                                              'Записей на странице',
                                              'widget',
                                              transl,
                                              'gridFilter'
                                          ))) + ':'}
                            </p>
                            <DropdownElement componentConfig={selectPageConfig} />
                        </div>
                    ) : null}
                    {!screenWidth && !pageSettings?.searchFilter && (
                        <div {...getStyleProps('searthTable')}>
                            {!pageSettings?.hideSearchInput ? (
                                <>
                                    <FormInput
                                        value={inputGlobFilter?.[0]}
                                        compStyle={{
                                            icon: { fill: 'var(--greyExtraDarkColor)' },
                                            wrapper: {
                                                ...stylers.searthTableInput,
                                                className: classes.searthTableInput
                                            },
                                            global: { icon: { width: '18px' } },
                                            clear: { icon: { width: '10px' } }
                                        }}
                                        handlers={{
                                            onChange: (val) => {
                                                globalSearch(val);
                                            }
                                        }}
                                        search={{
                                            type: 'onInput',
                                            icon: 'search-thin'
                                        }}
                                        placeholder={
                                            textsData.globalSearthPlaceholder ||
                                            t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                        }
                                        buttons={
                                            !pageSettings?.hideGlobalSearch
                                                ? {
                                                      global: {
                                                          icon: 'sliders',
                                                          handler: () => setShowModal(true)
                                                      },
                                                      ...(inputGlobFilter?.[0]
                                                          ? {
                                                                clear: {
                                                                    icon: 'cross',
                                                                    handler: () => {
                                                                        globalSearch('');
                                                                    }
                                                                }
                                                            }
                                                          : {})
                                                  }
                                                : {}
                                        }
                                    />
                                </>
                            ) : (
                                <div
                                    {...getStyleProps('searthFilterOpen', 'searthFilterOpenStatic', 'formCursorPointer')}
                                    onClick={() => setShowModal(true)}
                                >
                                    {svgSprite('search-thin', getStyleProps('userSearthSvgFillGrey'))}
                                </div>
                            )}
                        </div>
                    )}
                    {exportData ? <ExcelButton filter={dataFiltersToUrl} exportData={exportData} /> : null}
                </div>
            </div>
        </>
    );
};
export default AdminGridFilterHeader;
